import { closeDrawer } from "@/src/components/dialogs";

import { Hospitalisation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";

import {
    ListConstructor
} from "@/src/components/fetchableLists";
import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import { getItemId } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useState } from "react";
import AnesthesiologyConsultationCard from "./historique/anesthesiologyConsultationCard";
import AnesthesiologySummaryCard from "./historique/anesthesiologySummaryCard";
import InterventionCard from "./historique/interventionCard";
import { openEvolutionVisualisationDrawer } from "./openEvolutionVisualisation";

export function AnesthesiologySummariesList({
  patient,
  parent,
}: {
  patient: Patient;
  parent: Hospitalisation;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");
  let { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [
      "HospitalisationAnesthesiologySummariesList",
      searchKey,
      getItemId(parent),
      getItemId(patient),
      reload,
    ],
    queryFn: () =>
      apiFetch(
        "evolutionItems",
        "loadMany",
        {
          patientId: patient.id,
          parentId: parent?.id,
          selectedTableNames: [
            "interventions",
            "anesthesiologySummaries",
            "anesthesiologyConsultations",
          ],
        },
        "Erreur lors du chargement de l'historique"
      ),
  });

  let allItems = data || [];
  allItems = allItems.sort((a, b) => {
    return moment(a._date).diff(moment(b._date));
  });

  async function openVisualisation(index: number) {
    await openEvolutionVisualisationDrawer({
      items: allItems!,
      index,
      patient,
    });
  }

  function close() {
    closeDrawer("historyTypeDrawer");
  }

  return (
    <ListConstructor
      isLoading={isLoading}
      isError={isError}
      error={error}
      data={data?.length ? data : ["a"]}
    >
      <div className="grid c1 gap10">
        {allItems?.map((item, index) => {
          let child = <div></div>;
          let itemParent = parent;

          if (item.type === "intervention")
            child = (
              <InterventionCard
                parent={itemParent}
                item={item}
                patient={patient}
                onChange={async () => {
                  setReload((prev) => prev + 1);
                }}
                onClick={async () => {
                  await openVisualisation(index);
                }}
              />
            );

          if (item.type === "anesthesiologyConsultation")
            child = (
              <AnesthesiologyConsultationCard
                parent={itemParent}
                item={item}
                patient={patient}
                onChange={async () => {
                  setReload((prev) => prev + 1);
                }}
                onClick={async () => {
                  await openVisualisation(index);
                }}
              />
            );
          if (item.type === "anesthesiologySummary")
            child = (
              <AnesthesiologySummaryCard
                parent={itemParent}
                item={item}
                patient={patient}
                onChange={async () => {
                  setReload((prev) => prev + 1);
                }}
                onClick={async () => {
                  await openVisualisation(index);
                }}
              />
            );

          return (
            <StaggeredAnimation key={item?.id} index={index} increment={1}>
              {child}
            </StaggeredAnimation>
          );
        })}
      </div>
    </ListConstructor>
  );
}
